import { AUTHORIZATION_STATUS_LABELS } from './statusChip';

export const authorizationStatusOptions = Object.entries(AUTHORIZATION_STATUS_LABELS).map(
  ([value, label]) => ({
    value,
    label,
  })
);
